import Entity from "/src/js/engine/entity";
import Explosion from "./explosion";
import Hitbox from "/src/js/engine/hitbox";
import shootSFXURL from "url:/src/sounds/shoot.mp3";
export default class Bullet extends Entity{
    constructor({engine, position, direction, player}){
        super({engine,type:"bullet"});
        this.position = {...position};
        this.direction = {...direction};
        this.hitbox = new Hitbox({...this.position, w:50, h:3});
        this.player = player;
        this.speed = 1500;
        const sfx = new Audio(shootSFXURL);
        sfx.volume = 0.1;
        sfx.play();
    }

    update(){
        const s = this.engine.scaleFactor;
        this.position.x += this.direction.x * this.speed * this.engine.time.delta * s;
        this.position.y += this.direction.y * this.speed * this.engine.time.delta * s;
        if(this.position.x > this.engine.width){
            this.engine.destroyEntity(this);
        }
    }

    hit(){
        new Explosion({engine: this.engine, position: this.position, size: 100});
        this.engine.destroyEntity(this);
    }

    render(ctx){
        const s = this.engine.scaleFactor;
        const w = 50;
        const h = 3;

        let angle = Math.atan2(this.direction.y, this.direction.x);
        ctx.save();
        ctx.translate(this.position.x, this.position.y);
        ctx.shadowColor = "#7EFFE4";
        ctx.shadowBlur = 10 * s;
        ctx.fillStyle = "#7EFFE4";
        ctx.beginPath();
        ctx.rotate(angle);
        ctx.fillRect(-w/2 * s, -h/2 * s, w * s, h * s);
        ctx.fill();
        ctx.restore();

        this.hitbox.set({...this.position, w, h});
    }
}